import { render, staticRenderFns } from "./PersonalPropertyModal.vue?vue&type=template&id=3856c15e"
import script from "./PersonalPropertyModal.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyModal.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyModal.vue?vue&type=style&index=0&id=3856c15e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports